module.exports = __webpack_public_path__ + "static/media/logo_trail.c1fef5f0.svg";